import * as React from "react";
import type { SVGProps } from "react";
const SvgSparkHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.546 5.455a.66.66 0 0 1-.658-.66V2.58a.659.659 0 1 1 1.317 0v2.214a.66.66 0 0 1-.659.66M5.344 6.683 3.936 4.798a.663.663 0 0 1 .133-.923.655.655 0 0 1 .92.13L6.395 5.89a.663.663 0 0 1-.13.926.656.656 0 0 1-.922-.133M2.675 11.095l-2.274-.97a.663.663 0 0 1-.35-.867.656.656 0 0 1 .863-.35l2.275.97c.334.144.49.53.349.867a.66.66 0 0 1-.863.35M13.239 21.69c.738.518 1.72.518 2.459 0C18.058 20.035 23 16.13 23 12.415c0-1.298-.364-2.617-1.428-3.51-.926-.777-2.2-1.126-3.408-1.002-2.014.208-3 1.592-3.425 2.45a.302.302 0 0 1-.543 0c-.423-.858-1.41-2.242-3.423-2.45-1.207-.124-2.484.225-3.408 1.001-1.066.894-1.43 2.213-1.43 3.511 0 3.715 4.941 7.62 7.304 9.275"
    />
  </svg>
);
export default SvgSparkHeart;
